import * as api from "api/isometricDrawing";
import { useQuery } from "react-query";

export function useGetDrawingById(id?: string) {
  const drawingId = id ?? "";
  return useQuery(["drawing", drawingId], () => api.getDrawing(drawingId), {
    enabled: Boolean(id),
  });
}
